module.exports = __webpack_public_path__ + "dj.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/dj.svg
// module id = 772
// module chunks = 0